module.exports = __webpack_public_path__ + "static/img/enter-btn.a341afd2.png";